// extracted by mini-css-extract-plugin
module.exports = {"ball-scale-multiple":"ball-scale-multiple","loaderWrap":"loaderWrap"};